import { render, staticRenderFns } from "./honor.vue?vue&type=template&id=44a77e6b"
import script from "./honor.vue?vue&type=script&lang=js"
export * from "./honor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports